module.exports = __webpack_public_path__ + "img/17.2.TN.bbe28021.png";